import { createApiCall } from 'lib/base';

const POST_INVESTCORE_COMPANY_CREATE_API_ID =
  'DASHBOARD/POST_INVESTCORE_COMPANY_CREATE_API_ID';

const apiCall = createApiCall(
  POST_INVESTCORE_COMPANY_CREATE_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/companies`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
